import { jsx as e } from "react/jsx-runtime";
import { FieldLabel as r } from "../../FieldLabel/index.js";
import '../../../assets/index50.css';const t = "_label_nrwik_1", a = {
  label: t
};
function s({ children: l }) {
  return l ? /* @__PURE__ */ e(r, { className: a.label, children: l }) : null;
}
export {
  s as SelectFieldLabel
};
